import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

let refreshPromise = null;

axios.interceptors.response.use(
  response => response,
  async error => {
    const original = error.config;
    const isAuthRequest = original?.url?.includes("/api/login")
      || original?.url?.includes("/api/refresh");
    const shouldRefresh = error.response?.status === 401
      && !original?._retried
      && !isAuthRequest;

    if (!shouldRefresh) {
      return Promise.reject(error);
    }

    original._retried = true;
    refreshPromise = refreshPromise || axios
      .post("/api/refresh", null, {
        headers: {
          "X-XSRF-REFRESH-TOKEN": readCookie("XSRF-REFRESH-TOKEN"),
        },
        _retried: true,
      })
      .finally(() => {
        refreshPromise = null;
      });

    try {
      await refreshPromise;
      return axios(original);
    } catch (refreshError) {
      clearLegacyAuth();
      if (!original?._skipAuthRedirect && window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
      // Preserve the original protected request's 401 response. Individual
      // pages can then show the API's useful AUTH_REQUIRED/TOKEN_EXPIRED copy.
      return Promise.reject(error);
    }
  }
);

export function readCookie(name) {
  const prefix = `${encodeURIComponent(name)}=`;
  const item = document.cookie.split("; ").find(value => value.startsWith(prefix));
  return item ? decodeURIComponent(item.slice(prefix.length)) : "";
}

export function clearLegacyAuth() {
  ["token", "token_type", "expires_in", "expiration_time", "email"]
    .forEach(key => localStorage.removeItem(key));
}

export default axios;
